import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { postJson } from '../api';
import '../styles/SignIn.css';
import { useAuth } from '../context/AuthContext';

function SignIn() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false,
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const redirectTimeoutRef = useRef(null);

  useEffect(
    () => () => {
      if (redirectTimeoutRef.current) {
        clearTimeout(redirectTimeoutRef.current);
      }
    },
    [],
  );

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus({ type: '', message: '' });
    try {
      setIsSubmitting(true);
      const response = await postJson('/auth/signin', {
        email: formData.email.trim(),
        password: formData.password,
        rememberMe: formData.rememberMe,
      });
      if (!response || !response.user) {
        const fallbackError =
          response && response.error ? response.error : 'Failed to verify credentials.';
        throw new Error(fallbackError);
      }
      setUser(response.user);
      setStatus({
        type: 'success',
        message: response.message || 'Signed in successfully.',
      });
      setFormData((prev) => ({ ...prev, password: '' }));
      if (redirectTimeoutRef.current) {
        clearTimeout(redirectTimeoutRef.current);
      }
      redirectTimeoutRef.current = setTimeout(() => {
        navigate('/');
      }, 2000);
    } catch (error) {
      setStatus({ type: 'error', message: error.message });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container">
      <h2>Sign In</h2>
      <form className="signin-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="signin-email">Email:</label>
          <input
            id="signin-email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="signin-password">Password:</label>
          <input
            id="signin-password"
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>
        <div className="actions">
          <label>
            <input
              type="checkbox"
              name="rememberMe"
              checked={formData.rememberMe}
              onChange={handleChange}
            />{' '}
            Remember me
          </label>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Signing In...' : 'Sign In'}
          </button>
        </div>
      </form>
      {status.message && (
        <div
          role="status"
          aria-live="polite"
          className={`status-message ${status.type}`}
        >
          {status.message}
        </div>
      )}
    </div>
  );
}

export default SignIn;
